export default __webpack_public_path__ + "static/media/gallery_00.3a8388b5.jpg";